<template>
    <div class="login-page" :class="{ 'login-page--demo': isDemoVersion }">
        <div class="login-page__form">
        <transition name="fade">
        <LoginForm v-if="showLogin" />
        <posLoginForm v-else-if="showPOS" />
        <demoLogin v-else />
        
        </transition>
        </div>
        <DemoCustomers v-if="isDemoVersion" :language="lang.langname" />
    </div>
</template>

<script>
import LoginForm from "../components/LoginForm.vue";
import demoLogin from "../components/demoLogin.vue";
import posLoginForm from "../components/posLoginForm.vue";
import browserslist from 'browserslist';
export default{
    components: {
        LoginForm, posLoginForm, demoLogin,
        DemoCustomers: () => import('../components/DemoCustomers.vue')
    },
    data() {
        return {
            
        }
    },
    mounted() {
        browserslist.clearCaches()
        console.log('Browserslist caches cleared');
    },
    computed: {
        isDemoVersion() {
            const license = this.$store.state.licenseType;
            return !!license && (license.demoVersion === true || license.demoVersion === 1 || license.demoVersion === '1');
        },
        showLogin: function (){
            // return (this.$store.state.licenseType.POSREST == false && !this.$store.state.licenseType.POSRET ==false)
            if(this.$store.state.licenseType.POSREST || this.$store.state.licenseType.demoVersion){
                //return false;
            }
            return true;
        },
        showPOS: function(){
            if(this.$store.state.licenseType.POSREST && !this.$store.state.licenseType.demoVersion){
                //return true;
            }
            return false;
        },
        lang: {
            get() {
                if(this.$cookies.get(this.$store.state.LangCooki) != null){ 
                    if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                        return this.$store.state.lang.en;
                    } else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                        return this.$store.state.lang.ur;
                    }
                    else{
                        return this.$store.state.lang.ar;
                    }
                }
                else if(this.$store.state.deflang == 'en'){
                    return this.$store.state.lang.en;
                }else{
                    return this.$store.state.lang.ar;
                }
            },
            set(lang){
                this.$store.state.deflang = lang;
                if(this.$store.state.deflang == 'en'){
                    return this.$store.state.lang.en;
                } else if(this.$store.state.deflang == 'ur'){
                    return this.$store.state.lang.ur;
                } else{
                    return this.$store.state.lang.ar;
                }
            }
        },
    }
}
</script>

<style>
.login-page--demo {
  --demo-customers-height: 300px;
}

.login-page--demo .login-page__form {
  height: calc(100vh - var(--demo-customers-height) - 68px);
  height: calc(100dvh - var(--demo-customers-height) - 68px);
  overflow: auto;
}

.login-page--demo .login-page__form > .body > .row {
  margin: 0;
}

@media (max-height: 900px) {
  .login-page--demo .login-page__form > .body > .row > .col-md-6 > .mt-10 {
    margin-top: 0 !important;
    padding: 16px !important;
  }

  .login-page--demo .login-page__form .mt-10 > .mt-16 {
    margin-top: 16px !important;
  }
}

@media (max-width: 600px) {
  .login-page--demo { --demo-customers-height: 270px; }
}

@media (max-height: 600px) {
  .login-page--demo { --demo-customers-height: 220px; }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
